import src from "IMAGE";
export default { src, width: 130, height: 114, blurWidth: 0, blurHeight: 0};
